import { render, staticRenderFns } from "./ControllingYourInformation.vue?vue&type=template&id=1f5d5c8e&"
import script from "./ControllingYourInformation.vue?vue&type=script&lang=js&"
export * from "./ControllingYourInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports